module.exports = __webpack_public_path__ + "static/media/badge_highfive_1.b1e47534.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_highfive_1.png
// module id = 486
// module chunks = 0